module.exports = __webpack_public_path__ + "static/img/logo-wenzi.664c9f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo-wenzi.png
// module id = 6aSH
// module chunks = 1